module.exports = __webpack_public_path__ + "static/media/window-cleaning.1f5ca968.png";